import { Injectable } from '@angular/core';
import { SignupUserService } from '@app/modules/signup-new/services/signup-user.service';
import { SignupV2Value } from '@app/shared/interfaces/lib/posthog-flags.interface';
import { PosthogService } from '@app/shared/services/posthog/posthog.service';
import { BehaviorSubject, merge } from 'rxjs';
import { distinctUntilChanged, filter, map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SignupFlowService {
  flow$ = new BehaviorSubject<SignupV2Value>('B');

  constructor(
    private posthogService: PosthogService,
    private signupUserService: SignupUserService
  ) {
    merge(
      // filter out the possibility of an undefined value
      // since this service is used only in the new signup flow, we can also filter out the A value
      // we are also filtering out the posthog value if the user has already started the flow
      this.posthogService.signupV2Value$.pipe(
        filter((value) => !!value && value !== 'A' && !this.signupUserService.user$.value?.flow)
      ),
      // filter out situations where the user is not available or the user flow is set to A
      this.signupUserService.user$.pipe(
        map((user) => user?.flow),
        filter((value) => !!value && value !== 'A')
      )
    )
      .pipe(distinctUntilChanged())
      .subscribe((value) => this.flow$.next(value));
  }

  reset() {
    this.posthogService.signupV2Value$.pipe(take(1)).subscribe((value) => this.flow$.next(value || 'B'));
  }
}
